import { render, staticRenderFns } from "./LaunchSignVar.vue?vue&type=template&id=70a05b5c&scoped=true"
import script from "./LaunchSignVar.vue?vue&type=script&lang=js"
export * from "./LaunchSignVar.vue?vue&type=script&lang=js"
import style0 from "./LaunchSignVar.vue?vue&type=style&index=0&id=70a05b5c&prod&lang=less"
import style1 from "./LaunchSignVar.vue?vue&type=style&index=1&id=70a05b5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a05b5c",
  null
  
)

export default component.exports